export default __webpack_public_path__ + "static/media/logo-para-web-grupo.1369baad.png";